angular.module('pl-shared')
  .factory('moment', function($window) {
    return $window.moment
  })
